import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-remove-product-dialog',
  templateUrl: './remove-product-dialog.component.html',
  styleUrls: ['./remove-product-dialog.component.scss']
})
export class RemoveProductDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<RemoveProductDialogComponent>,

    @Inject(MAT_DIALOG_DATA) public data: {
      id: string,
      title: string,
      code: string
    },
  ) {}

  onConfirm(id: string) {
    this.dialogRef.close({ id: id });
  }
}
